import { Check, Close } from '@mui/icons-material';
import {
  Alert,
  Collapse,
  IconButton,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import BaseButton from '../../components/common/BaseButton';
import api from '../../utils/api';
import { useTranslation } from 'react-i18next';
const CustomAlert = styled(Alert)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 180, 171, 1)' : '#FFDAD6',
  padding: theme.spacing(1, 3),
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 600,
  position: 'relative',
  borderRadius: '0',
  '.MuiAlert-message': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.primary.dark,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 3),
      flexWrap: 'wrap',
    },
  },
  '.MuiAlert-action': {
    margin: 0,
    padding: 0,
    color: theme.palette.primary.dark,
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
  },
}));

const AlertBox = ({ email = '', sx = {} }) => {
  const [open, setOpen] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { t } = useTranslation();

  const resendEmail = async () => {
    setLoadingButton(true);

    setLoadingButton(false);
  };

  return (
    <Collapse in={open}>
      <CustomAlert
        sx={{ ...sx }}
        icon={
          mdUp ? (
            <Check sx={{ color: 'transparent' }} fontSize="inherit" />
          ) : (
            false
          )
        }
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <Close sx={{ color: 'secondary.neutral_10' }} fontSize="inherit" />
          </IconButton>
        }
      >
        <Typography sx={{ color: 'secondary.neutral_10' }}>
          {t('alert.verified_email')}
        </Typography>
        <BaseButton
          disabled={loadingButton}
          loading={loadingButton}
          onClick={resendEmail}
          sx={{
            fontSize: '12px',
            py: mdUp ? 1.5 : 2.5,
            ml: (theme) => (theme.direction === 'ltr' && mdUp ? 3 : 0),
            mr: (theme) => (theme.direction === 'rtl' && mdUp ? 3 : 0),
            width: mdUp ? 'auto' : '100%',
            mt: mdUp ? 0 : 4,
          }}
        >
          {t('button_text.resend')}
        </BaseButton>
      </CustomAlert>
    </Collapse>
  );
};
export default AlertBox;
